import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssFileProgressPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    @observable
    protected ex1File: File | null = null;

    protected ex1Progress: number = -1;
    protected ex1MaxFileSize = 40 * 1024 * 1024;
    protected ex1UploadError: string | null = null;
    protected ex1UnsupportedMediaType: boolean = false;

    private ex1FileChanged(): void {
        if(this.ex1File && this.ex1File.size > this.ex1MaxFileSize) {
            this.ex1Progress = -1;
            this.ex1UploadError = 'ui:messages.errors.upload.maximumSizeExceeded';
            return;
        }
        this.ex1UploadFile();
    }

    private ex1UploadFile(): void {
        if(!this.ex1File) { return; }

        try {
            this.state.beginUpload();
            this.ex1UploadError = null;
            this.ex1Progress = 0;

            if(this.ex1UnsupportedMediaType) {
                this.ex1UploadError = 'ui:messages.errors.upload.unsupportedMediaType';
                this.ex1Progress = -1;
                return;
            }

            const simulateUpload = setInterval(() => {
                if(this.ex1Progress >= 1) {
                    clearInterval(simulateUpload);
                }
                this.ex1Progress += 0.05;
            }, 100);
        }
        catch(error) {
            let uploadError: string = 'ui:messages.errors.upload.$';
            this.ex1UploadError = uploadError;
            this.ex1Progress = -1;

            throw error;
        }
        finally {
            this.state.endUpload();
        }
    }

}
